<jni-orders [orderType]="'inventory-sales'"></jni-orders>
